<twc-wizard #wizard caption="{{ 'JOB_SITE.VIEWER.TOC_BUTTONS.ADD_PROJECT_LAYER' | translate}}">
    <twc-wizard-steps>
        <twc-wizard-step label="{{'GENERAL.SELECT' | translate}}">
            <cw-select-data-type *ngIf="isFirstPage"
                (selectedTypeChanged)="setSelectedType($event)"></cw-select-data-type>
        </twc-wizard-step>
        <twc-wizard-step label="{{'GENERAL.ADD' | translate}}">
            <cw-create-project-content *ngIf="isCreateProject" [type]="projectType" [shouldSkipLayers]="true"
                [shouldSkipAclCheck]="true" [isCreateButtonHidden]="true" [shouldOpenProjectViewer]="false"
                [jobSite]="jobSite" (loadingChanged)="setLoading($event)"></cw-create-project-content>
            <cw-create-wizard-input-data *ngIf="isUploadWizard"
                [subtitle]="uploadWizardService.wizardSubtitle"></cw-create-wizard-input-data>
            <cw-select-existing-project *ngIf="isExisting" [jobSiteId]="jobSite?.id"
                [shouldSelectCheckboxOnClick]="true"></cw-select-existing-project>
            <cw-create-wizard-input-data *ngIf="isNewLayer"
                [subtitle]="uploadWizardService.wizardSubtitle"></cw-create-wizard-input-data>
        </twc-wizard-step>
        <twc-wizard-step label="{{'WIZARD.TAB_NEW_PROJECT' | translate}}" *ngIf="isUploadWizardSelected">
            <cw-create-project-wizard-project-data *ngIf="isUploadWizard">
            </cw-create-project-wizard-project-data>
        </twc-wizard-step>
        <twc-wizard-step label="{{'WIZARD.TAB_LAYER_OPTIONS' | translate}}" *ngIf="isNewLayerSelected">
            <cw-add-layer-options *ngIf="isNewLayer && hasFile"></cw-add-layer-options>
        </twc-wizard-step>
        <twc-wizard-step cwHideStepIcon label="{{'WIZARD.TAB_SUMMARY' | translate}}" *ngIf="isUploadWizardSelected || isNewLayerSelected">
            <cw-create-wizard-summary [subtitle]="uploadWizardService.wizardSubtitle"
                [showEstimationMessage]="uploadWizardService.canEstimateCredits"
                *ngIf="isUploadWizard || isNewLayer"></cw-create-wizard-summary>
        </twc-wizard-step>
    </twc-wizard-steps>
    <twc-wizard-footer *ngIf="isFirstPage || isCreateProject || isExisting" [ngClass]="{'twc-mt-2': isExisting}">
        <button *ngIf="isSinglePage" class="twc-button twc-button-link" (click)="popup.onClose()">
            {{'GENERAL.CLOSE' | translate}}
        </button>
        <button *ngIf="!isSinglePage" [disabled]="isFirstPage" class="twc-button twc-button-link"
            (click)="onPrevious()">{{ 'WIZARD.PREVIOUS'
            | translate}}</button>
        <button *ngIf="hasNextButton" [disabled]="!selectedDataType" class="twc-button twc-button-primary"
            (click)="onNext()">{{
            'WIZARD.NEXT' | translate}}</button>
        <button *ngIf="!hasNextButton && isCreateProject" (click)="onCreate()" [twcLoading]="isLoading"
            [attr.disabled]="!isValid || null" class="twc-button twc-button-primary">{{ 'WIZARD.CREATE'
            | translate}}</button>
        <!-- TODO: Workaround until TWC fixed the disabled property -->
        <button *ngIf="!hasNextButton && isExisting" (click)="onCreate()"
            [attr.disabled]="areNoProjectsSelected || null" [twcLoading]="isLoading"
            class="twc-button twc-button-primary">
            {{ 'CREATE_PROJECT.ADD_PROJECT' | translate}}
        </button>
    </twc-wizard-footer>
    <twc-wizard-footer *ngIf="isUploadWizard || isNewLayer">
        <button class="twc-button twc-button-link" (click)="onPrevious()" [disabled]="isUploadStarted">
            {{'WIZARD.PREVIOUS' | translate}}
        </button>
        <button class="twc-button twc-button-primary" *ngIf="isNextButtonVisible" (click)="onWizardNext()"
            [disabled]="!isNextButtonEnabled">
            {{'WIZARD.NEXT' | translate}}
        </button>
        <button class="twc-button twc-button-primary" *ngIf="isUploadButtonVisible" (click)="onUploadButtonClick()">
            {{'WIZARD.UPLOAD_AND_PROCESS' | translate}}
        </button>
        <button class="twc-button twc-button-primary" *ngIf="isAddLayerButtonVisible" (click)="createAndUploadReferenceData()">
            {{'WIZARD.ADD_LAYER' | translate}}
        </button>
        <button class="twc-button twc-button-primary" *ngIf="isCloseButtonVisible" [twcLoading]="isLoading" (click)="wizard.onClose()">
            {{'GENERAL.CLOSE' | translate}}
        </button>
    </twc-wizard-footer>
</twc-wizard>